export { default } from './ProductDetail'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductDetail/index.js